import { createContext, useContext, useState } from "react";
import { AuthContext } from "./auth.context";

export const ChatContext = createContext({
	chats: null,
	selectedChat: null,
	setSelectedChat: () => {},
	sendMessage: () => {},
});

const CHATS = {
	1: {
		name: "Can Karaman",
		userId: 10,
		matchId: 1,
		numberOfUnreads: 10,
		lastMessage: {},
		// lastMessage: { message: "HEllooooooooooooooooooooooooooooooooooooooo", date: new Date() },
		messages: [],
	},
	3: {
		name: "Umut Can Özmekik",
		userId: 12,
		matchId: 3,
		numberOfUnreads: 0,
		lastMessage: {},
		// lastMessage: { message: "HElloooooooooooooooooo", date: new Date() },
		messages: [],
	},
};

const ChatProvider = ({ children }) => {
	const { user } = useContext(AuthContext);

	const [chats, setChats] = useState(CHATS);
	const [selectedChat, setSelectedChat] = useState(null);

	const { userId } = user ?? 0;

	const sendMessage = (message, receiverId, matchId) => {
		const newMessage = { message, receiverId, senderId: userId, date: Date.now() };
		setChats((initialChat) => {
			const tempChats = { ...initialChat };
			tempChats[matchId].messages.splice(0, 0, newMessage);
			tempChats[matchId].lastMessage = newMessage;
			return tempChats;
		});
	};

	const value = { chats, selectedChat, setSelectedChat, sendMessage };
	return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

export default ChatProvider;
